import { useContext } from "react";
import { SongPlayerContext, SongPlayerContextType } from "../contexts/songPlayerContext";

const useSongPlayer = (): SongPlayerContextType => {
	const context = useContext(SongPlayerContext);

	if (!context) {
		throw new Error('useSongPlayer must be used within a SongPlayerProvider.');
	}

	return context;
};

export default useSongPlayer;